import { getItemsText } from "../common/utilities";
import findByStrings from "../FindBy/strings";
const {
  findButtonAriaLabel
} = findByStrings;
const STRINGS = {
  summaryText: (selected, total) => `${selected} of ${total} selected`,
  selectionDetails: null,
  errorMessage: label => `Enter ${label}`,
  addPanelTitle: "Add",
  editPanelTitle: "Edit",
  panelBodyTitle: null,
  applyButtonLabel: "Apply",
  cancelButtonLabel: "Cancel",
  selectedCountMessage: count => `${count} selected`,
  feedbackInstruction: null,
  feedbackMinSelectionError: "",
  feedbackMaxSelectionError: "",
  findAnnouncement: filteredRecordCount => getItemsText(filteredRecordCount),
  findButtonAriaLabel,
  toolbarAriaLabel: "",
  getMinMaxSameInstruction: count => `Select ${count} items to continue.`,
  getMinOnlyInstruction: count => `Select at least ${count} items to continue.`,
  getMaxOnlyInstruction: count => `Select up to ${count} items to continue.`,
  getMinAndMaxInstruction: (min, max) => `Select between ${min} and ${max} items to continue.`,
  getMaxErrorForMinMaxConfig: max => `More than ${max} items selected.`,
  getMinErrorForMinMaxConfig: min => `Fewer than ${min} items selected.`,
  defaultInstruction: "Select items to continue."
};
export default STRINGS;